<template>
  <tr class="mds-data-table__row client-row">
    <td class="mds-data-table__cell">
      <div v-if="isPending" class="pending-icon mds-icon">
        <svg class="mds-icon" aria-hidden="true">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="static/mds/icons/mds.svg#clock-back"
          ></use>
        </svg>
      </div>
    </td>
    <td class="mds-data-table__cell" scope="row">
      <slot></slot>
    </td>
    <td class="mds-data-table__cell">
      {{ category }}
    </td>
    <td class="mds-data-table__cell"></td>
    <td class="mds-data-table__cell">
      <status-icons :status="[{ name: status }]" />
      {{ status }}
    </td>
    <td class="mds-data-table__cell">
      <template v-if="newStatus">
        <status-icons :status="[{ name: newStatusIcon }]" />
        {{ newStatusText }}
      </template>
    </td>
  </tr>
</template>
<script>
import StatusIcons from '@/components/atoms/StatusIcons';

export default {
  name: 'change-status-clients-list',
  components: {
    StatusIcons,
  },
  props: {
    category: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    newStatus: {
      type: Number,
      default: 0,
    },
    newStatusIcon: {
      type: String,
      default: '',
    },
    newStatusText: {
      type: String,
      default: '',
    },
    isPending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.client-row {
  background-color: $mds-color-neutral-95;
  border-bottom: 1px solid $mds-color-neutral-90;

  & td {
    padding-bottom: $mds-space-2-x;
    padding-top: $mds-space-2-x;
  }
  & td:first-child {
    padding-left: $mds-space-inset-half-x;
  }
  & div[class^="status-array"] {
    display: inline;
  }
  & .status-icons {
    margin-right: $mds-space-half-x;
  }
}
</style>
